import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import CompanyRepository from "../../Repository/CompanyRepository";
import UserRepository from "../../Repository/UserRepository";

const initialState = {
  companyLoading: false,
  error: "",
  company: "",
};

export const getCompany = createAsyncThunk("company/fetchCompany", () => {
  let tokenType = localStorage.getItem("tokenType");
  if (tokenType == "user") {
    return UserRepository.usersModel({
      request: {
        method: "getUser",
        data: {
          _id: localStorage.getItem("companyId"),
        },
      },
    })
      .then(({ data }) => data.response.data.user)
      .catch((err) => console.log(err));
  } else {
    return CompanyRepository.companyModel({
      request: {
        method: "getCompany",
        data: {
          _id: localStorage.getItem("companyCode"),
        },
      },
    })
      .then(({ data }) => data.response.data.company[0])
      .catch((err) => console.log(err));
  }
});

export const companySlice = createSlice({
  name: "company",
  initialState,

  reducers: {
    addRegion: (state, action) => {
      state.company = action.payload;
    },
    clearCompany: (state, action) => {
      state.company = "";
    },
    updateGst: (state, action) => {
      const { gst, gstType } = action.payload;
      state.company.gst = gst;
      state.company.gstType = gstType;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getCompany.pending, (state) => {
      state.companyLoading = true;
    });
    builder.addCase(getCompany.fulfilled, (state, action) => {
      state.companyLoading = false;
      state.company = action.payload;
      state.error = "";
      let gst = action.payload?.gst;
       let income = action.payload;

      let gstType = action.payload?.gstType;
      console.log('income', income)
      if (gst) {
        localStorage.setItem("gst", gst);
        localStorage.setItem("gstType", gstType);
      } else if (income ) {
        localStorage.setItem("income", income.income);

      }
    });
    builder.addCase(getCompany.rejected, (state, action) => {
      state.companyLoading = false;
      state.company = "";
      state.error = action.error.message;
    });
  },
});

export const { addRegion, clearCompany, updateGst } = companySlice.actions;

export default companySlice.reducer;
